import React from "react";

const SecondaryBtn = ({ children, className, onClick }) => {
  return (
    <button
      className={`
        ${className} 
        btn 
        text-white 
        flex items-center gap-2 
        bg-violet-600/30 backdrop-blur-md 
        rounded-lg 
        hover:bg-gradient-to-r hover:from-violet-500 hover:to-indigo-500 
        hover:shadow-lg 
        transition-all duration-500
        border-none
      `}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default SecondaryBtn;
